// Notification Service for Admin Panel
export const requestNotificationPermission = async () => {
  // Check if browser supports notifications
  if (!('Notification' in window)) {
    console.log('This browser does not support notifications');
    return false;
  }

  // Check if notification permission is already granted
  if (Notification.permission === 'granted') {
    return true;
  }

  // Request permission if not denied
  if (Notification.permission !== 'denied') {
    try {
      const permission = await Notification.requestPermission();
      return permission === 'granted';
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      return false;
    }
  }

  return false;
};

export const sendAdminNotification = (submissionData) => {
  // Only send if permission is granted
  if (Notification.permission === 'granted') {
    const { firstName, lastName, email, phone, service, source } = submissionData;
    
    const notificationTitle = `New ${source === 'contact_page' ? 'Contact' : 'Inquiry'} Submission`;
    
    const notificationOptions = {
      icon: '/img/favicon.ico', // Add your favicon path
      badge: '/img/favicon.ico',
      tag: 'form-submission',
      requireInteraction: true, // Keep notification visible until user interacts
      body: `${firstName} ${lastName || ''} from ${email} is interested!\n\nService: ${service || 'Not specified'}\nPhone: ${phone || 'Not provided'}`,
      data: {
        submissionEmail: email,
        submissionSource: source,
        submissionTime: new Date().toLocaleTimeString(),
      }
    };

    try {
      const notification = new Notification(notificationTitle, notificationOptions);
      
      // Optional: Close notification after 10 seconds
      setTimeout(() => {
        notification.close();
      }, 10000);

      // Click notification to open admin panel
      notification.onclick = () => {
        // Set flag to show admin panel
        localStorage.setItem('showAdminPanelOnLoad', 'true');
        window.focus();
        notification.close();
      };
    } catch (error) {
      console.error('Error sending notification:', error);
    }
  }
};

export const checkNotificationSupport = () => {
  return 'Notification' in window;
};
